import { useContext, useEffect, useState } from "react";
import { Check, ChevronDown, Plus } from "lucide-react";
import {
	Autocomplete,
	TextField,
	Box,
	Grid,
	OutlinedInput,
	Typography,
	Button,
} from "@mui/material";

import { AssitanceAdjustViewContext } from "../../../components/AssistanceAdjustList/AssistanceAdjustList";
import grain from "../../../assets/images/grain.png";
import "../AssitanceAdjustModals.scss";

export default function AddNurseModal() {
	const {
		availableNurses,
		availableAreas,
		selectedArea,
		selectedNurse,
		isModalLoading,
		saveMovements,
		showModal,
		onItemSelected,
		clearFieldsNClose,
	} = useContext(AssitanceAdjustViewContext);

	const [localSelectedNurse, setLocalSelectedNurse] = useState("");
	const [localSelectedArea, setLocalSelectedArea] = useState("");

	useEffect(() => {
		setLocalSelectedNurse(selectedNurse);
		setLocalSelectedArea(selectedArea);
	}, [showModal]);

	const options = availableAreas
		.sort((a: any, b: any) => a.area.localeCompare(b.area))
		.filter((area: any) => area.area !== "SOPORTE");

	const nurseOptions = availableNurses.sort((a: any, b: any) => a.name.localeCompare(b.name));

	const canSave = (): boolean => {
		return localSelectedNurse !== "" && localSelectedArea !== "";
	};

	const handleSave = () => {
		saveMovements({
			newNurse: localSelectedNurse,
			area: localSelectedArea,
		});
	};

	return (
		<Box>
			<Box className="modal-header">
				<img
					className="modal-header__grain"
					src={grain}
					alt="background"
				/>
				<Box className="modal-header__title">
					<Plus className="modal-header__title__icon" />
					<Box className="modal-header__title__text">
						<Typography className="modal-header__title__text--name">
							Agregar Profesional
						</Typography>
						<Typography className="modal-header__title__text--description">
							Añade un profesional al turno y asígnale un sector.
						</Typography>
					</Box>
				</Box>
			</Box>
			<Grid
				container
				spacing={1}
				className="modal-form"
			>
				<Grid
					item
					xs={8}
				>
					<Typography className="modal-form__input-title">Profesional</Typography>
					<Autocomplete
						popupIcon={<ChevronDown className="down-icon" />}
						id="selectProfessional"
						options={nurseOptions}
						getOptionLabel={(option: any) => option.name}
						onChange={(e, value?: any) => onItemSelected(value)}
						size="small"
						renderInput={(params) => (
							<TextField
								{...params}
								variant="outlined"
								placeholder="Seleccionar"
								sx={{
									"& .MuiOutlinedInput-root": { height: "3rem" },
								}}
							/>
						)}
						value={
							availableNurses.find((name: any) => name.id === localSelectedNurse) ||
							null
						}
					/>
				</Grid>
				<Grid
					item
					xs={4}
				>
					<Typography
						sx={{ textAlign: "start" }}
						className="modal-form__input-title"
					>
						Categoría
					</Typography>
					<OutlinedInput
						fullWidth
						disabled
						className="modal-form__disabled-input"
						placeholder={"-"}
						value={
							availableNurses.find((e: any) => e.id === localSelectedNurse)
								? availableNurses.find((e: any) => e.id === localSelectedNurse)
										.class
								: ""
						}
						size="small"
					></OutlinedInput>
				</Grid>
				<Grid
					item
					xs={12}
				>
					<Typography className="modal-form__input-title">Sector</Typography>
					<Autocomplete
						popupIcon={<ChevronDown className="down-icon" />}
						id="selectSector"
						options={options}
						getOptionLabel={(option: any) => option.area}
						onChange={(e, value: any) => {
							setLocalSelectedArea(value?.id ?? "");
						}}
						size="small"
						renderInput={(params) => (
							<TextField
								{...params}
								variant="outlined"
								sx={{
									"& .MuiOutlinedInput-root": { height: "3rem" },
								}}
							/>
						)}
						value={
							availableAreas.find((area: any) => area.id === localSelectedArea) ||
							null
						}
					/>
				</Grid>
			</Grid>
			<Box className="buttons">
				<Button
					className="buttons--close"
					onClick={clearFieldsNClose}
				>
					Cerrar
				</Button>

				<Button
					id="save-button"
					className="buttons--save"
					startIcon={<Check className="buttons--save__icon" />}
					onClick={() => handleSave()}
					disabled={!canSave() || isModalLoading}
				>
					Guardar
				</Button>
			</Box>
			{isModalLoading && (
				<Box>
					<Box className="loader-container"></Box>
					<Box className="loader-container__loader"></Box>
				</Box>
			)}
		</Box>
	);
}
